import { Component, OnInit, ViewChild } from "@angular/core";

import { ActivatedRoute, Params, Router } from "@angular/router";
import { AreasService } from "../../master-services/area-services/areas.service";
import swal from "sweetalert2";
import { Console, error } from "console";
import { OrderService } from "../../master-services/order-service/orderservice.service";
import {
  NgbCalendar,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

@Component({
  selector: "app-master-imports-detail",
  templateUrl: "./master-imports-detail.component.html",
  styleUrls: ["./master-imports-detail.component.scss"],
})
export class MasterimportsDetailComponent implements OnInit {
  @ViewChild("modalRegisterItem") modalRegisterItem;
  ////Comienza Espacio para declaraciones /////

  priceListMap: { [key: number]: string } = {
    0: "Seleccione origen",
    2: "USA",
    3: "ESPAÑA",
    4: "BELGICA",
    5: "SERVICIO TERCERO",
    6: "REPUESTO NACIONAL",
    7: "SIN",
    8: "USA FPE",
    9: "FLORIDA",
    10: "KANSAS",
    11: "MPE",
    12: "Back Order",
  };

  stateListMap: { [key: number]: string } = {
    0: "En canasta",
    1: "Llego el pedido",
    2: "Despachado",
  };
  selectedItem: any = {};
  priceListArray: { key: number; value: string }[] = [];
  consecutive: any;
  now: any;
  user: any;
  selectedOriginId: number = 0;
  state: number = 0;
  import_order: any;
  filteredOrders: any;
  emailLogist: any;
  imports_order_detail_DIST: any;
  import_order_disponible: any;

  importOrderconsecutive: number = 0;

  orderBy: string = ""; // Campo por el que se ordena
  orderDirection: boolean = true; // true = ascendente, false = descendente
  ordersFlat: any;

  secondImportOder: any[] = [];
  thirImportOder: any[] = [];
  idDeleteBackOrder: any[] = [];
  newUpdateBackOrder: any[] = [];
  selectedOrders: any[] = [];
  totalWeight: number = 0;
  totalPLD: number = 0;

  ////Termina Espacio para declaraciones /////
  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private orderservice: OrderService,
    private calendar: NgbCalendar
  ) {
    this.importOrderconsecutive = this.rutaActiva.snapshot.params.id;
    // this.ngOnInit();
  }
  ngOnInit() {
    // console.log("Acaaa desde el init en import detalle");
    // console.log(
    //   "Acaaa desde el init en import detalle con consecutivo de importacion",
    //   this.importOrderconsecutive
    // );
    this.getImportOrder();
    this.getImportOrders_DIST();
    this.getImportOrders_detail_DIST();
  }

  getPriceListName(priceList: number): string {
    return this.priceListMap[priceList] || "Desconocido";
  }
  getImportOrder() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservice
      .getImportOrderBasket()
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.import_order_disponible = resp.data;
        console.warn(
          "Data recibida de Importorders:",
          this.import_order_disponible
        );
        this.import_order_disponible.unshift({
          import_order_consecutive: 1,
          selected_origin_id: 12,
        });

        console.log("Nuevo valor agregado:", this.import_order_disponible);
        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getImportOrders_DIST() {
    //console.warn("Acaaa implementacion de metodo para obtener data normalita.");
    this.orderservice
      .getImportOrder_selected(this.importOrderconsecutive)
      .then((data) => {
        const resp: any = data;

        this.import_order = resp.data;
        console.log(
          "Data recibida de ordenes de IMPORTACIONES Normal:",
          this.import_order
        );
      })

      .catch((error) => {
        console.log(error);
      });
  }
  getImportOrders_detail_DIST() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservice
      .getImportOrder_detail_dist_basket(this.importOrderconsecutive)
      .then((data) => {
        const resp: any = data;
        console.log("Acaaa la resp", resp);

        this.imports_order_detail_DIST = data;
        console.log(
          "Data recibida de ordenes de IMPORTACIONES Detalle:",
          this.imports_order_detail_DIST
        );
        this.ordersFlat = this.imports_order_detail_DIST;
        console.warn("Acaaa Ordenes flat", this.ordersFlat);
        this.totalWeight = this.imports_order_detail_DIST.reduce(
          (sum, o) => sum + o.cant_imports * parseFloat(o.weight),
          0
        );
        this.totalPLD = this.imports_order_detail_DIST.reduce(
          (sum, o) => sum + parseFloat(o.unit_cost) * o.cant_imports,
          0
        );
        console.warn("Acaa totales de peso y PLD",this.totalPLD,this.totalWeight);
        swal.close();

        /////Filtrando los datos para mostrarlos en la tabla y estados
      })

      .catch((error) => {
        console.log(error);
      });
  }

  formatDate(dateString: string): string {
    if (!dateString) return "";

    const date = new Date(dateString);

    const day = date.getUTCDate().toString().padStart(2, "0");
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = date.getUTCFullYear();

    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  backOrderItem(item: any) {
    console.log("Acaaaa item para backorder", item);
    const od_id = item.od_id;
    const id = item.id;
    console.log("Acaaaa Recuperando id", id);
    console.warn("Acaaaa Recuperando od_id", od_id);

    this.selectedItem = { ...item };
  }
      ////Esta es la funcion de excel vieja
  // exportExcel() {
  //   console.warn("Acaa excel");
  //   const data = this.imports_order_detail_DIST.map((order) => ({
  //     "Orden de pedido": order.orderserviceConsecutive || "",
  //     "Pedido de importacion": order.importOrderConsecutive || "",
  //     Cliente: order.customer_name || "",
  //     Código: order.code || "",

  //     Descripción: order.description || "",
  //     Importar: order.cant_imports || "",
  //     "PID USD Unit": order.unit_cost || "",
  //     "PID USD Total":
  //       order.cant_imports && order.unit_cost
  //         ? (order.cant_imports * order.unit_cost).toFixed(2)
  //         : "",
  //     "Peso Unit": order.weight || "",
  //     "Peso Total":
  //       order.weight && order.cant_imports
  //         ? (order.weight * order.cant_imports).toFixed(2)
  //         : "",
  //     Origen: this.priceListMap[order.price_list || ""],
      
  //     Bodega: order.warehouse_description || "",
  //   }));

  //   // Crear el libro de Excel
  //   const worksheet = XLSX.utils.json_to_sheet(data);
  //   const workbook = XLSX.utils.book_new();

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Resumen de productos");

  //   // Generar el archivo Excel
  //   const excelBuffer: any = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });
  //   const file = new Blob([excelBuffer], { type: "application/octet-stream" });

  //   // Descargar el archivo
  //   saveAs(
  //     file,
  //     `Resumen_Productos_${this.importOrderconsecutive}--${new Date()
  //       .toISOString()
  //       .slice(0, 10)}.xlsx`
  //   );
  // }
  exportExcel2() {
    console.warn("Acaa excel");
    const data = this.imports_order_detail_DIST.map((order) => ({
      "Orden de pedido": order.orderserviceConsecutive || "",
      "Pedido de importacion": order.importOrderConsecutive || "",
      Cliente: order.customer_name || "",
      Código: order.code || "",
      Descripción: order.description || "",
      Importar: order.cant_imports ? Number(order.cant_imports) : 0,
      "PID USD Unit": order.unit_cost ? Number(order.unit_cost) : 0,
      "PID USD Total":
        order.cant_imports && order.unit_cost
          ? Number((order.cant_imports * order.unit_cost).toFixed(2))
          : 0,
      "Peso Unit": order.weight ? Number(order.weight) : 0,
      "Peso Total":
        order.weight && order.cant_imports
          ? Number((order.weight * order.cant_imports).toFixed(2))
          : 0,
      Origen: this.priceListMap[order.price_list || ""],
      Solicitante: order.comercial_name || "",
      Bodega: order.warehouse_description || "",
      "Observacion": order.order_observation || "",
    }));
  
    // Crear el libro de Excel
    const worksheet = XLSX.utils.json_to_sheet(data);
  
    // Ajustar el formato de las celdas
    Object.keys(worksheet).forEach((cell) => {
      if (cell.startsWith("A") || cell.startsWith("B")) return; // Evitar modificar las columnas de texto
      if (worksheet[cell].t === "s" && !isNaN(Number(worksheet[cell].v))) {
        worksheet[cell].t = "n"; // Cambiar a tipo número
        worksheet[cell].v = Number(worksheet[cell].v);
      }
    });
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Resumen de productos");
  
    // Generar el archivo Excel
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const file = new Blob([excelBuffer], { type: "application/octet-stream" });
  
    // Descargar el archivo
    saveAs(
      file,
      `Resumen_Productos_${this.importOrderconsecutive}--${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`
    );
  }

  addImportOrder(order: any) {
    console.warn("Acaa paso la orderId", order);
    console.warn("Acaa paso la Id", order.import_order_detail_id);
    if (!order.importDetails) {
      order.importDetails = [];
    }
    order.importDetails.push({
      import_order_consecutive: "",
      other_cant_imports: null,
    });
  }

  setOrder(field: string) {
    if (this.orderBy === field) {
      this.orderDirection = !this.orderDirection;
    } else {
      this.orderBy = field;
      this.orderDirection = true;
    }

    this.ordersFlat.sort((a: any, b: any) => {
      const valueA = a[field];
      const valueB = b[field];

      // Verificar si es un número o un string
      if (typeof valueA === "number" && typeof valueB === "number") {
        return this.orderDirection ? valueA - valueB : valueB - valueA;
      } else {
        return this.orderDirection
          ? valueA.toString().localeCompare(valueB.toString())
          : valueB.toString().localeCompare(valueA.toString());
      }
    });
  }

  removeImportField(order: any, index: number) {
    order.importDetails.splice(index, 1);
  }

  confirmNewImportOrderDetail(order: any) {
    console.log("Acaaa paso la  order", order);

    // Calcula la suma de las cantidades ingresadas en los inputs
    const totalQuantityEntered = order.importDetails.reduce(
      (sum: number, importDetail: any) => {
        return sum + (importDetail.other_cant_imports || 0);
      },
      0
    );

    // Verifica si la suma de las cantidades es igual a order.cant_imports
    if (totalQuantityEntered !== order.cant_imports) {
      console.warn(
        `La cantidad total ingresada (${totalQuantityEntered}) no coincide con la cantidad de importación (${order.cant_imports}).`
      );
      swal({
        title: "Las cantidades deben coincidir",
        text: "Error",
        type: "error",
      });
      return;
    }
    const id = order.import_order_detail_id;
    console.log("acaaa id para borrar", id);
    this.idDeleteBackOrder.push(id);
    const roundToTwoDecimals = (value: string | number) =>
      parseFloat(value as string).toFixed(2);

    const thirdArray = order.importDetails
      .filter(
        (importDetail: any) => importDetail.import_order_consecutive === "1"
      )
      .map((importDetail: any) => ({
        orderserviceConsecutive: order.orderserviceConsecutive,
        importOrderConsecutive:  Number(importDetail.import_order_consecutive),
        cant_disp: order.cant_disp,
        cant_imports: importDetail.other_cant_imports,
        crossReferenceCode: order.crossReferenceCode,
        customer_name: order.customer_name,
        description: order.description,
        estimateConsecutive: order.estimateConsecutive,
        order_observation: order.order_observation,
        price_list: order.price_list,
        total_quantity: order.total_quantity,
        unit_cost: order.unit_cost,
        PID_unit: Number(roundToTwoDecimals(order.unit_cost)),
        warehouse_description: order.warehouse_description,
        weight:  Number(roundToTwoDecimals(order.weight)),
        weight_type: order.weight_type,
        quantity_toImport: importDetail.other_cant_imports,
        code: order.code,
        backOrder: 1,
        product_arrived: 0,
        product_remision: 0,
        product_registered: 0,
        cant_registered: 0,
        stock: 0,
        od_id: order.od_id,
        order_logis_id: order.order_logis_id,
        petitioner_email:order.petitioner_email,
        comercial_name:order.comercial_name,

        //id: order.id,
      }));

    console.warn("🚀 thirdArray generado:", thirdArray);
   
  
  this.thirImportOder.push(...thirdArray);

    // Si la validación pasa, se genera el array newImportData
    const newImportData = order.importDetails
      .filter(
        (importDetail: any) => importDetail.import_order_consecutive !== "1"
      )
      .map((importDetail: any) => ({
        orderserviceConsecutive: order.orderserviceConsecutive,
        importOrderConsecutive:  Number(importDetail.import_order_consecutive),
        cant_disp: order.cant_disp,
        cant_imports: importDetail.other_cant_imports,
        crossReferenceCode: order.crossReferenceCode,
        customer_name: order.customer_name,
        description: order.description,
        estimateConsecutive: order.estimateConsecutive,
        order_observation: order.order_observation,
        price_list: order.price_list,
        total_quantity: order.total_quantity,
        unit_cost: order.unit_cost,
        PID_unit: Number(roundToTwoDecimals(order.unit_cost)),
        warehouse_description: order.warehouse_description,
        weight:  Number(roundToTwoDecimals(order.weight)),
        weight_type: order.weight_type,
        quantity_toImport: importDetail.other_cant_imports,
        code: order.code,
        backOrder: 0,
        product_arrived: 0,
        product_remision: 0,
        product_registered: 0,
        cant_registered: 0,
        stock: 0,
        od_id: order.od_id,
        order_logis_id: order.order_logis_id,
        petitioner_email:order.petitioner_email,
        comercial_name:order.comercial_name,
        // id: order.id,
      }));

    console.warn("🚀 newImportData generado:", newImportData);

    // Agregar los datos validados al array this.secondImportOder y sacarlo del primero
    this.secondImportOder.push(...newImportData);

    this.imports_order_detail_DIST = this.imports_order_detail_DIST.filter(
      (selectedOrder: any) =>
        selectedOrder.import_order_detail_id !== order.import_order_detail_id
    );
    this.totalWeight = this.imports_order_detail_DIST.reduce(
      (sum, o) => sum + o.cant_imports * parseFloat(o.weight),
      0
    );
    this.totalPLD = this.imports_order_detail_DIST.reduce(
      (sum, o) => sum + parseFloat(o.unit_cost) * o.cant_imports,
      0
    );
    //console.log("Datos de importación confirmados:", newImportData);
    console.log(
      "Orden eliminada de imports_order_detail_DIST, nuevo estado:",
      this.imports_order_detail_DIST
    );
    console.log("segundo array de ordenes:", this.secondImportOder);

    this.newUpdateBackOrder = [
      ...this.secondImportOder,
      ...this.thirImportOder,
    ];

    console.warn("Acaaaa newUpdateBackOrder", this.newUpdateBackOrder);
    console.warn("Acaaa ids a eliminar", this.idDeleteBackOrder);
  }

  confirmNewImportBackorder() {
    console.warn("Acaaa confirmacion back order", this.newUpdateBackOrder);
    console.warn("Acaaa ids a eliminar", this.idDeleteBackOrder);
    const data={ids_delete: this.idDeleteBackOrder, combinedData: this.newUpdateBackOrder}
    console.log("Acaaaa pasando la data",data);
  
     this.orderservice.createImportOrderDetailFromBackOrder(data).then((data) => {
           if (data && typeof data === "object" && "success" in data) {
             console.log("Se ha creado el post", data);
             swal({
               title: "Se ha registrado los pedidos de importacion",
               type: "success",
             });
             swal.close();
            this.router.navigateByUrl("erp/Importsorder");
             
           } else {
             console.log("Error al crear POSTLOGIST:", data);
             // Manejo Adicional de errores
             swal.close();
             swal({
               title: "Los items deben de asociarse a un numero de pedido",
               type: "error",
             });
           }
         });
         
  }

  ////
}



// WEBPACK FOOTER //
// ./src/app/master/master-imports-detail/master-imports-detail.component.ts